// extracted by mini-css-extract-plugin
export default {"campaignName":"CampaignActionMenu__campaignName-ZdYR9"};